(() => {
  if (window.__AFX_CS_INIT__) return;
  window.__AFX_CS_INIT__ = true;

  const getBtnFromEvent = (e) => {
    const path = typeof e.composedPath === "function" ? e.composedPath() : [];
    for (const el of path) {
      if (el && el.nodeType === 1 && el.matches && el.matches("[data-afx-add]")) return el;
    }
    return e.target && e.target.closest ? e.target.closest("[data-afx-add]") : null;
  };

  const cartAddUrl = () => {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url + ".js";
    return "/cart/add.js";
  };

  async function addToCart(variantId) {
    const res = await fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error("Add failed: " + txt);
    }
    return res.json();
  }

  async function forceRefreshDrawer() {
    // Pedimos el mismo HTML de la página/cart y extraemos los contenedores XO
    const res = await fetch(window.location.pathname + "?_afx_drawer_refresh=1", {
      headers: { "Accept": "text/html" }
    });
    const html = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const newContent = doc.querySelector("xo-cart-will-change[xo-unique-id='xo-cart-mini-content']");
    const newFooter  = doc.querySelector("xo-cart-will-change[xo-unique-id='xo-cart-mini-drawer-footer']");

    const curContent = document.querySelector("xo-cart-will-change[xo-unique-id='xo-cart-mini-content']");
    const curFooter  = document.querySelector("xo-cart-will-change[xo-unique-id='xo-cart-mini-drawer-footer']");

    if (newContent && curContent) curContent.innerHTML = newContent.innerHTML;
    if (newFooter && curFooter)   curFooter.innerHTML  = newFooter.innerHTML;

    // por si el theme recalcula algo
    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new CustomEvent("xo:cart:updated"));
  }

  document.addEventListener("click", async (e) => {
    const btn = getBtnFromEvent(e);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = btn.getAttribute("data-variant-id");
    if (!variantId) return;

    if (btn.disabled) return;

    const original = btn.textContent;
    btn.disabled = true;
    btn.textContent = "ADDING…";

    btn.style.transform = "translateY(1px) scale(.98)";
    setTimeout(() => (btn.style.transform = ""), 140);

    try {
      await addToCart(variantId);

      btn.textContent = "ADDED ✓";

      // ✅ refresco visual forzado
      await forceRefreshDrawer();

      setTimeout(() => (btn.textContent = original), 700);
    } catch (err) {
      console.error("[AFX CS] error:", err);
      btn.textContent = "ERROR";
      setTimeout(() => (btn.textContent = original), 900);
    } finally {
      setTimeout(() => (btn.disabled = false), 350);
    }
  }, true);
})();